export default __webpack_public_path__ + "43b803bfaa8b15eb2ac5a31dd99a6e67.png";